import { render, staticRenderFns } from "./SurveyComponent.vue?vue&type=template&id=14edd21c"
import script from "./SurveyComponent.vue?vue&type=script&lang=js"
export * from "./SurveyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports